<template>

	<div class="navigation-menu-container-mobile">

		<v-btn
			icon
			color="#ffffff"
			@click="toggleDrawer()">
			<v-icon color="#ffffff" large>mdi-menu</v-icon>
		</v-btn>

		<v-menu
			v-model="openMenu"
			absolute
			transition="slide-x-reverse-transition"
			:position-y="SUBMENU_POSITION_Y"
			:position-x="SUBMENU_POSITION_X">
			<template v-slot:activator="{ on, attrs }">

				<div class="item-menu-container navigation-menu-item-container navigation-menu-mobile"
					v-bind="attrs"
					v-on="on">
					<v-icon large :class="{'rotate-90': openMenu}">{{ NAVIGATION_SUB_MENU_CONFIGS.icon }}</v-icon>
				</div>
			</template>

			<v-list
				class="header-menu-list">

				<template 
					v-for="menuItem in NAVIGATION_SUB_MENU_CONFIGS.children">

					<div v-if="hasVisibilityPermission(menuItem)"
						v-bind:key="menuItem.label"
						class="header-menu-item">
						<v-list-item class="pa-1">
							<v-icon class="mr-1">{{ menuItem.icon }}</v-icon>
							<a :href="menuItem.href">{{ menuItem.label }}</a>
						</v-list-item>
					</div>

				</template>
			</v-list>

		</v-menu>
	</div>

</template>

<style>
	.navigation-menu-container-mobile {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding: 0 10px;
		justify-content: space-between;
	}

	.navigation-menu-mobile {
		color: #ffffff;
		font-size: 14px;
	}

	.navigation-menu-mobile .v-icon {
		color: #ffffff !important;
		font-size: 12px;
	}

	navigation-menu-item a {
		padding: 0 3px 0 3px;
		text-decoration: none;
	}

	.header-menu-list a {
		text-decoration: none;
		color: #222222 !important;
	}

	.header-menu-item {
		font-size: 15px;
		border-bottom: 1px solid #dedede;
		margin: 0 7px 0 4px;
		line-height: 30px;
	}

</style>

<script>
import { 
	NAVIGATION_MENU_CONFIGS, 
	NAVIGATION_SUB_MENU_CONFIGS, 
	NAVIGATION_MENU_AUTH_CONFIGS 
} from './NavigationMenuConfigs.js';

const { Utils } = require('@/assets/js/scripts/utils/Utils.js');

export default {
	name: 'NavigationMenuMobile',
	props: [
		'prop_user',
	],

	data() {
		return {
			openMenu: false,

			SUBMENU_POSITION_Y: 93,
			SUBMENU_POSITION_X: 0,

			NAVIGATION_MENU_CONFIGS,
			NAVIGATION_SUB_MENU_CONFIGS,
			NAVIGATION_MENU_AUTH_CONFIGS,
		}
	},

	methods: {
		hasVisibilityPermission(item) {
			if (Utils.isNullOrUndefined(item)) {
				return false;
			}

			let requiresPermission = !Utils.isNullOrUndefined(item.codePermission);

			if (requiresPermission) {
				if (Utils.isNullOrUndefined(this.prop_user) || Utils.isNullOrUndefined(this.prop_user.permissions)) {
					//Le prop sono undefined
					return false;
				}

				let visible = Utils.isTrueLoose(this.prop_user.permissions[item.codePermission]);
				return visible;

			} else {
				//non profilato
				return true;
			}
		},

		toggleDrawer() {
			this.$emit('toggle_drawer');
		},
	},

}
</script>

